export const LIFECYCLE_EVENTS = {
  PAUSE: 'LIFECYCLE_PAUSE',
  RESUME: 'LIFECYCLE_RESUME',
  RESUME_RESULT: 'LIFECYCLE_RESUME_RESULT',
};
